angular.module('bmsApp.resource')
	.controller('ResourceDirectoryPinVerificationDialogCtrl', [
		'notify',
		'ResourceSvc',
		'$modalInstance',
		'directory',
		'CRUDSvc',
		function (notify,
				  ResourceSvc,
				  $modalInstance,
				  directory,
				  CRUDSvc) {

			var self = this;
			var form = {
				validator: {
					config: {},
					api: {}
				},
				processing: false
			};
			angular.extend(self, {
				directory: directory,
				form: form,
				methods: {
					cancel: cancel,
					submit: submit
				}
			});

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit(form) {
				var params = {
					id: self.directory.id,
					pin: self.pin
				};
				CRUDSvc.checkPin(params)
					.then(function (response) {
					$modalInstance.close(self.pin);
					}, function (errors) {
						var apiErrors = '';
						for (var i in errors) {
							apiErrors +=  errors[i];
						}
						notify({
							message: apiErrors
						});
					});
			}

		}
	]);
